import { useParseRouteActions } from "../../../helpers/GlobalHelper";
import LmsTable from "../ui/LmsTable";

const MainTable = () => {
  const actionsButtons = ["export"];
  return <LmsTable
    actionButtons={actionsButtons}
    apiSuffix="menu/invoice"
    columnClickOptions={{
      attachment: {
        idProp: "documentLogId",
        downloadPath: "document/download"
      }
    }}
  />;
};

const LmsNewMenusInvoice = ({ params = {}, history }) => {
  const { isActionAllowed } = useParseRouteActions(params);
  if (!isActionAllowed) {
    history.goBack();
  }
  
  return (<MainTable />);
};

export default LmsNewMenusInvoice;